<div class="extern-footer-html">

    <div class="footerContainer">
        <div class="footerLeft">
            {{ footerTextCopyright }}
        </div>
        <div class="footerRight">
            <a href="{{ urlFooterWkvPortal }}" target="_blank" rel="noopener noreferrer">WKV-Portal</a> /
            <a href="{{ urlFooterImpressum }}" target="_blank" rel="noopener noreferrer">Impressum</a> /
            <a href="{{ urlFooterDatenschutz }}" target="_blank" rel="noopener noreferrer">Datenschutz</a> /
            <a href="{{ urlFooterHilfe }}" target="_blank" rel="noopener noreferrer">Hilfe</a>
        </div>
    </div>

</div>
